// ContactForm.jsx
import React, { useState, useRef, forwardRef } from "react";
import "../styles/RegulatoryCompliance.css";
import { FaCheckCircle } from "react-icons/fa";

const ContactForm = forwardRef((props, ref) => {
  const formRef = useRef();
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = formRef.current;
    const formData = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/mdkzepgd", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (response.ok) {
        setShowModal(true);
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      alert("Submission failed. Please check your network and try again.");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    formRef.current.reset();
  };

  return (
    <>
      <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>
        <h3>Get In-touch with Us</h3>
        <input type="text" name="name" placeholder="Your name" required />
        <input
          type="email"
          name="email"
          placeholder="Your Email Address"
          required
        />
        <textarea name="message" placeholder="Your message" required></textarea>
        <button type="submit">Send email</button>
      </form>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="icon-success">
              <FaCheckCircle />
            </div>
            <h4>Form successfully submitted!</h4>
            <button onClick={handleCloseModal}>Okay</button>
          </div>
        </div>
      )}
    </>
  );
});

export default ContactForm;
